export default __webpack_public_path__ + "static/media/utilityprocess.6f092c1e.png";